window.NavigatorSearchInputController = {
	init: function() {
		const RESULT_CLASS_NAME = 'has-navigator-result';

		function resize(baseEl, wrapperEl) {
			const $el = $(this);

			const maxWidth = wrapperEl.width();
			const width = baseEl.width();

			const base = parseInt($(this).css('font-size'));
			const newPos = maxWidth - width - 40 < 0 ? 0 : maxWidth - width - 40;
			$el.css('transform', `translate(${-1 * newPos}px, 0em)`);
		}

		function checkVal(value) {
			if (value.length > 0) {
				$(this).addClass('not-empty')
			} else {
				$(this).removeClass('not-empty')
			}
		}

		const $search = $('.b-navigator-search');

		$search.each(function () {
			const $this = $(this);
			const $field = $('input', $this);
			const $placeholder = $('.b-navigator-search__placeholder', $this);
			const $rightVector = $('.b-navigator-search__right-vector', $this);
			const $label = $('.b-navigator-search__label', $this);
			const DEFAULT_TEXT = $field.attr('placeholder');

			const updateStatus = checkVal.bind($this);
			const updateSize = resize.bind($rightVector[0], $placeholder, $label);

			const startValue = $field.val();

			if (startValue) {
				$placeholder.text(startValue);
				updateStatus(startValue);
			} else {
				$placeholder.text(DEFAULT_TEXT);
			}

			updateSize();

			const observer = new MutationObserver((MutationRecords) => {
				for (let mutation of MutationRecords) {
					if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
						$rightVector.addClass('not-animated');

						const newVal = $field.val();
						$placeholder.text(newVal);
						updateSize();

						$search.one('transitionend', () => {
							$rightVector.removeClass('not-animated');
						})
					}
				}
			});

			observer.observe(document.body, {
				attributeFilter: ['class'],
				subtree: false,
				childList: false,
				characterDataOldValue: false,
			});

			$field.on('keyup keypress change input focus paste', () => {
				$this.addClass('is-focus');
				const newVal = $field.val();

				$placeholder.text(newVal);

				updateSize();
				updateStatus(newVal);
			});

			$("[type='reset']").on('click', function () {
				$this.removeClass('not-empty is-focus');
				$('.b-navigator-search__tips', $this).remove();

				$placeholder.text(DEFAULT_TEXT);
				updateSize();
			});

			$field.on('blur', () => {
				$this.removeClass('is-focus');

				if (!$field.val().length) {
					$placeholder.text(DEFAULT_TEXT);
				} else {
					$placeholder.text($field.val());
				}
				updateSize()
			});
		})
	}
};
$(function () {
	NavigatorSearchInputController.init();
})
;
